import React from 'react';



function OneSlider() {

  return (
	  <section className="slider-area slider-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-9">
              <div className="slider-content text-center">
                <h6 className="wow fadeInDown" data-wow-delay=".2s">moon force</h6>
                <h2 className="tlt fix" data-in-effect="fadeInLeft">Safe <span>Moon</span></h2>
                <p className="wow fadeInUp" data-wow-delay="2s">Unleash your inner space warrior, harness the power of your spaceship and weapons, and lead the Safe-Moon Defenders to victory in the face of alien invaders.</p>
                <a href="/#/game-single" className="btn wow fadeInUp" data-wow-delay="2.2s">Join The fight</a>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default OneSlider;
